import {useEffect, useState} from 'react';
import {useDebouncedCallback} from 'use-debounce';

const useDebounceSearchTerm = (value: string | undefined, delay: number): string | undefined => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    const debouncedCallback = useDebouncedCallback((val) => {
        setDebouncedValue(val);
    }, delay);

    useEffect(() => {
        debouncedCallback(value);
    }, [value, debouncedCallback]);

    return debouncedValue;
};

export default useDebounceSearchTerm;
